import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const createMarkdownElement = (type, baseClassName) => {
  const MarkdownElement = ({ className = '', children, ...rest }) =>
    React.createElement(
      type,
      {
        className: cx(baseClassName, className),
        'data-test-locator': `Markdown ${type}`,
        ...rest,
      },
      children,
    );

  MarkdownElement.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
  };
  MarkdownElement.defaultProps = {
    className: null,
    children: null,
  };

  return MarkdownElement;
};
export { createMarkdownElement };
